// @flow
import { handleActions, type ActionType } from 'redux-actions';
import {
  requestClientQueueContent,
  receiveClientQueueContent,
  receiveClientQueueError,
} from './channelContentQueueActions';

type ChannelContentQueueShape = {
  ugcId: ?number,
  contentRequestStatus: RequestStatus,
};

const defaultState: ChannelContentQueueShape = {
  ugcId: null,
  contentRequestStatus: null,
};

export default handleActions(
  {
    [requestClientQueueContent.toString()]: (
      state: ChannelContentQueueShape,
      action: ActionType<typeof requestClientQueueContent>
    ) => ({ ...state, contentRequestStatus: 'pending' }),

    [receiveClientQueueContent.toString()]: (
      state: ChannelContentQueueShape,
      action: ActionType<typeof receiveClientQueueContent>
    ) => ({
      ...state,
      ugcId: action.payload.ugc_id,
      contentRequestStatus: 'complete',
    }),

    [receiveClientQueueError.toString()]: (
      state: ChannelContentQueueShape,
      action: ActionType<typeof receiveClientQueueError>
    ) => ({ ...state, contentRequestStatus: action.payload.status }),
  },
  defaultState
);



// WEBPACK FOOTER //
// ./src/containers/channels/channelContentQueueReducer.js